export enum ProjectModelEndpointType {
  System = 'System',
  Custom = 'Custom'
};
